import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useUrlPagination(defaultPageSize = 50) {
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, parseInt(params.get('page') ?? '1', 10));
  const pageSize = Math.max(1, parseInt(params.get('pageSize') ?? String(defaultPageSize), 10));
  const q = params.get('q') ?? '';

  const setPage = useCallback(
    (p: number) => {
      const next = new URLSearchParams(params);
      next.set('page', String(p));
      setParams(next, { replace: true });
    },
    [params, setParams],
  );
  const setPageSize = useCallback(
    (s: number) => {
      const next = new URLSearchParams(params);
      next.set('pageSize', String(s));
      next.set('page', '1');
      setParams(next, { replace: true });
    },
    [params, setParams],
  );

  return useMemo(
    () => ({ page, pageSize, q, setPage, setPageSize }),
    [page, pageSize, q, setPage, setPageSize],
  );
}
